import { useEffect } from 'react';
import { useAtom } from 'jotai';
import { sidebarOpenAtom, sidebarOpenMobileAtom } from '../../Services/store/atoms';

const SIDEBAR_KEYBOARD_SHORTCUT = 'b';

export const useSideBar = () => {
  const [open, setOpen] = useAtom(sidebarOpenAtom);
  const [openMobile, setOpenMobile] = useAtom(sidebarOpenMobileAtom);

  const toggleSidebar = () => setOpen((prev) => !prev);
  const toggleMobileSidebar = () => setOpenMobile((prev) => !prev);

  useEffect(() => {
    const handler = (e) => {
      if (e.key === SIDEBAR_KEYBOARD_SHORTCUT && (e.metaKey || e.ctrlKey)) {
        e.preventDefault();
        toggleSidebar();
      }
    };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, []);

  return { open, setOpen, openMobile, setOpenMobile, toggleSidebar, toggleMobileSidebar };
};

// Provider kept for backward compatibility (no-op, atoms are global)
export const SideBarProvider = ({ children }) => children;
